import { useEffect, useState } from "react";

const UseOnlineStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isSlowConnection, setIsSlowConnection] = useState(false);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    
    if (connection) {
      const updateConnectionStatus = () => {
        // Effective type tracks 3g, 2g, or slow 4g
        const slowTypes = ['slow-2g', '2g', '3g'];
        if (slowTypes.includes(connection.effectiveType) || connection.saveData) {
          setIsSlowConnection(true);
        } else {
          setIsSlowConnection(false);
        }
      };

      updateConnectionStatus();
      connection.addEventListener('change', updateConnectionStatus);
      
      return () => {
        connection.removeEventListener('change', updateConnectionStatus);
      };
    }

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return {isOnline, isSlowConnection};
};

export default UseOnlineStatus;